import React from "react";
import { Box, Typography, CardContent, Divider, Chip } from "@mui/material";
import { StyledCard } from "../../common/StyledCard";
import { getEntityMeta } from "../../../helpers/dashboardHelpers";
import { VoteHeadStatsDto } from "../../../shared/dtos/voteHead/VoteHeadStatsDto";

interface VoteHeadWidgetProps {
  data: VoteHeadStatsDto;
}

const VoteHeadWidget: React.FC<VoteHeadWidgetProps> = ({ data }) => {
  const meta = getEntityMeta("VOTE_HEAD");
  const Icon = meta.icon;

  const topPriorities = data.topPrioritizedVoteHeadNames || [];

  return (
    <StyledCard
      sx={{ height: "100%", display: "flex", flexDirection: "column" }}
    >
      <CardContent>
        <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
          <Box
            sx={{
              p: 1,
              borderRadius: 1,
              bgcolor: `${meta.color}15`,
              color: meta.color,
              display: "flex",
              mr: 2,
            }}
          >
            <Icon />
          </Box>
          <Typography variant="h6" sx={{ fontWeight: "bold" }}>
            {meta.title}
          </Typography>
        </Box>

        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            my: 2,
          }}
        >
          <Box sx={{ textAlign: "center" }}>
            <Typography variant="h4" sx={{ fontWeight: "bold" }}>
              {data.totalVoteHeads}
            </Typography>
            <Typography variant="body2" sx={{ color: "text.secondary" }}>
              Total Categories
            </Typography>
          </Box>
          <Box sx={{ textAlign: "center" }}>
            <Typography variant="h4" sx={{ fontWeight: "bold" }}>
              {data.totalRecurringVoteHeads}
            </Typography>
            <Typography variant="body2" sx={{ color: "text.secondary" }}>
              Recurring
            </Typography>
          </Box>
        </Box>

        <Divider sx={{ my: 2 }} />

        <Box>
          <Typography variant="body2" sx={{ color: "text.secondary", mb: 1 }}>
            Top Priorities
          </Typography>
          {topPriorities.length > 0 ? (
            <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1 }}>
              {topPriorities.map((name, index) => (
                <Chip
                  key={index}
                  label={name}
                  size="small"
                  variant="outlined"
                  sx={{
                    borderColor: meta.color,
                    color: meta.color,
                    fontWeight: "bold",
                  }}
                />
              ))}
            </Box>
          ) : (
            <Typography variant="caption" sx={{ color: "text.disabled" }}>
              No prioritized vote heads found.
            </Typography>
          )}
        </Box>
      </CardContent>
    </StyledCard>
  );
};

export default VoteHeadWidget;
